import PropTypes from 'prop-types';

import { Avatar } from '@mui/material';

import hotelBusinessAvatar from 'assets/images/users/hotel-business-avatar.png';

const HotelBusinessAvatar = ({ size = 36, sx, ...props }) => (
  <Avatar
    src={hotelBusinessAvatar}
    alt="酒店账号头像"
    {...props}
    sx={{
      width: size,
      height: size,
      borderRadius: '8px',
      bgcolor: '#102A25',
      border: '1px solid rgba(16,42,37,0.18)',
      boxShadow: '0 1px 4px rgba(16,42,37,0.12)',
      '& img': {
        objectFit: 'cover'
      },
      ...sx
    }}
  />
);

HotelBusinessAvatar.propTypes = {
  size: PropTypes.number,
  sx: PropTypes.object
};

export default HotelBusinessAvatar;
